import type { QueryFilterConfig } from '@/types/common/table-config.type';

export const query: QueryFilterConfig = objFilter => {
    return {};
};
